import { render } from "./Index.vue?vue&type=template&id=57ea627d&ts=true"
import script from "./Index.vue?vue&type=script&lang=ts&setup=true"
export * from "./Index.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/builds/easy/webapp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Admin/WeatherStations/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "57ea627d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('57ea627d', __exports__)) {
    console.log('reload')
    api.reload('57ea627d', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=57ea627d&ts=true", () => {
    console.log('re-render')
    api.rerender('57ea627d', render)
  })

}


export default __exports__